import { extendTailwindMerge } from "tailwind-merge";
import { clsx, type ClassValue } from "clsx";

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "ring-w": [{ "ring-w": [() => true] }],
      "ring-color": [{ "ring-color": [() => true] }],
    },
  },
});
// just here temporarily till we merge cy-ui with cy-fe
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(...inputs));
  // return twMerge(clsx(...inputs));
  // return clsx(...inputs);
}
